<template>
  <section>
    <b-form-group
      id="orderNumberGroup"
      label="Order ID:"
      label-for="orderNumberGroup"
    >
    <b-input-group>
      <b-input-group-prepend is-text>
        <i class='fas fa-fw fa-globe'></i> &nbsp; <i class='fb-icon'></i>
      </b-input-group-prepend>
      <b-form-input
        id="orderNumber"
        type="text"
        v-model="fields.orderNumber"
      />
      </b-input-group>
    </b-form-group>
    <b-form-group
      id="nameGroup"
      label="Name:"
      label-for="nameGroup"
    >
    <b-input-group>
      <b-input-group-prepend is-text>
        <i class='fb-icon'></i>
      </b-input-group-prepend>
      <b-form-input
        id="name"
        type="text"
        v-model="fields.address.name"
      />
      </b-input-group>
    </b-form-group>
    <b-form-group
      id="emailGroup"
      label="E-mail:"
      label-for="emailGroup"
    >
    <b-input-group prepend-html="<i class='fas fa-fw fa-globe'></i> &nbsp; <i class='fb-icon'></i>">
      <b-form-input
        id="email"
        type="text"
        v-model="fields.email"
        autocomplete="search-email"
      />
      </b-input-group>
    </b-form-group>
    <b-form-group
      id="totalPriceGroup"
      label="Total Price:"
      label-for="totalPriceGroup"
    >
    <b-input-group prepend-html="<i class='fas fa-fw fa-globe'></i> &nbsp; <i class='fb-icon'></i>">
      <b-form-input
        id="totalPrice"
        type="text"
        v-model="fields.totalPrice"
      />
      </b-input-group>
    </b-form-group>
    <b-form-group
      id="customerPurchaseOrderGroup"
      label="Customer Purchase Order:"
      label-for="customerPurchaseOrderGroup"
    >
    <b-input-group prepend-html="<i class='fb-icon'></i>">
      <b-form-input
        id="customerPurchaseOrder"
        type="text"
        v-model="fields.customerPurchaseOrder"
      />
      </b-input-group>
    </b-form-group>
    <b-form-group
      id="customerTeamNumberGroup"
      label="Team Number:"
      label-for="customerTeamNumberGroup"
    >
    <b-input-group>
      <b-input-group-prepend is-text>
        <i class='fas fa-fw fa-globe'></i>
      </b-input-group-prepend>
      <b-form-input
        id="customerTeamNumber"
        type="text"
        v-model="fields.teamNumber"
      />
      </b-input-group>
    </b-form-group>
    <b-form-group
      id="ccLastFourGroup"
      label="CC Last 4 Digits:"
      label-for="ccLastFourGroup"
    >
    <b-input-group>
      <b-input-group-prepend is-text>
        <i class='fas fa-fw fa-globe'></i>
      </b-input-group-prepend>
      <b-form-input
        id="ccLastFour"
        type="text"
        v-model="fields.ccLastFour"
      />
      </b-input-group>
    </b-form-group>
    <b-form-group
      id="ipAddress"
      label="IP Address:"
      label-for="ipAddressGroup"
    >
    <b-input-group>
      <b-input-group-prepend is-text>
        <i class='fas fa-fw fa-globe'></i>
      </b-input-group-prepend>
      <b-form-input
        id="ipAddress"
        type="text"
        v-model="fields.ipAddress"
      />
      </b-input-group>
    </b-form-group>
  </section>
</template>

<script>
export default {
  props: {
    fields: { type: Object, default: {} },
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/sales-order/order-forms/OrderDetails.vue